import { createContext, useContext, ReactNode, useEffect, useState } from "react";
import { InteractiveBrowserCredential } from "@azure/identity";
import config from "./Config";

interface AuthContextType {
  credential: InteractiveBrowserCredential;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [credential] = useState(
    () =>
      new InteractiveBrowserCredential({
        tenantId: config.tenantId,
        clientId: config.clientId,
        loginStyle: "popup",
      })
  );

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        await credential.getToken("https://api.loganalytics.io/.default");
        setIsAuthenticated(true);
      } catch (error) {
        console.error("Authentication failed:", error);
      }
    };

    authenticateUser();
  }, [credential]);

  if (!isAuthenticated) {
    return <div>Authenticating...</div>;
  }

  return (
    <AuthContext.Provider value={{ credential, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
